module.exports = __webpack_public_path__ + "static/media/Dark Grey 15-2.2cee81f3.jpg";